export function formatField(key: string, value: string | number): string {
  if (!value) return "";

  switch (key) {
    case "job_type":
      return value
        .toString()
        .replace("-", " ")
        .replace(/\b\w/g, (c) => c.toUpperCase()); // full-time → Full Time

    case "employee_count":
      return value.toString().replace("_", "-"); // 31_50 → 31-50

    case "salary": {
      const num = typeof value === "string" ? parseFloat(value) : value;
      if (isNaN(num)) return value.toString();
      return num.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }); // 120.00 → 120 / 10,000.50 → 10,000.5
    }

    default:
      return value.toString();
  }
}
